import React, { useState } from "react";
import styled from "styled-components";
import feed1 from "../assets/feed1.png";
import useInViewAnimation from "../hooks/useInViewAnimation";
import { motion } from "framer-motion";

function Page2Mobile() {
  const variant1 = {
    visible: {
      opacity: 1,
      transition: { duration: 0.7 },
    },
    hidden: { opacity: 0 },
  };
  const variant2 = {
    visible: {
      scale: 1,
      opacity: 1,
      transition: { duration: 0.7, delay: 0.2 },
    },
    hidden: { scale: 0.97, opacity: 0 },
  };
  const variant3 = {
    visible: {
      opacity: 1,
      transition: { duration: 0.7, delay: 0.2 },
    },
    hidden: { opacity: 0 },
  };
  const [ref1, control1] = useInViewAnimation(0.7);
  return (
    <MainContainer id="with-js-lap">
      <Title initial="hidden" variants={variant1} animate={control1}>
        with js Lap
      </Title>
      <Grid initial="hidden" variants={variant2} animate={control1}>
        <Box ref={ref1}>
          <Img src={feed1} />
        </Box>
      </Grid>
      <Button
        initial="hidden"
        variants={variant3}
        animate={control1}
        onClick={() => {
          window.open("https://instagram.com/js_lap?igshid=OGQ5ZDc2ODk2ZA==");
        }}
      >
        <ButtonText>더보기</ButtonText>
      </Button>
    </MainContainer>
  );
}

export default Page2Mobile;
const MainContainer = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #070707;
  z-index: 10;
  padding-bottom: 151px;
  overflow: hidden;
  position: relative;
`;
const Title = styled(motion.p)`
  color: #fff;
  font-family: Pretendard;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px; /* 150% */
  margin-top: 70px;
`;
const Grid = styled(motion.div)`
  width: 80vw;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 60px;
`;
const Box = styled.div`
  width: 80vw;
  height: 80vw;
  background: white;
`;
const Button = styled(motion.div)`
  cursor: pointer;
  display: flex;
  width: 130px;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  border: 1px solid #aaa;
  background: #000;
  margin-top: 40px;
`;
const ButtonText = styled.p`
  color: #fff;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 175% */
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
